const pickOr = <T>(defaultValue: T) => {
    return <K>(cond: boolean, value: K) => {
        return cond ? value : defaultValue;
    };
};
const pickOrUndefined = pickOr(undefined);
const pickOrEmptyObj = pickOr({});
const pickOrArray = pickOr([]);
const pickOrFalse = pickOr(false);
const pickFirstOr = <T>(defaultValue: T) => {
    return <K>(arr?: K[]) => {
        return arr && arr.length > 0 ? arr[0] : defaultValue;
    };
};
const pickFirstOrString = pickFirstOr('');
const valueIfNotEmpty = <T>(value: T, possiblyEmpty?: object) => {
    if (!possiblyEmpty) {
        return {};
    }

    return Object.keys(possiblyEmpty).length > 0 ? value : {};
};

export {
    pickOr,
    pickFirstOr,
    pickOrFalse,
    pickOrEmptyObj,
    pickOrArray,
    pickOrUndefined,
    pickFirstOrString,
    valueIfNotEmpty,
};
